import createApi from "../utils/apiClient";
const api = createApi();

// ── Sports ──
export const getSports = () => async (dispatch) => {
  try {
    dispatch({ type: "SPORTS_REQUEST" });
    const { data } = await api.get("/sports");
    dispatch({ type: "SPORTS_SUCCESS", payload: data.sports });
  } catch (err) {
    dispatch({ type: "SPORTS_FAIL", payload: err.response?.data?.message });
  }
};
export const createSport = (d) => async (dispatch) => {
  try {
    await api.post("/sports", d);
    dispatch(getSports());
  } catch (err) {
    throw err;
  }
};
export const updateSport = (id, d) => async (dispatch) => {
  try {
    await api.put(`/sports/${id}`, d);
    dispatch(getSports());
  } catch (err) {
    throw err;
  }
};

// ── Roster ──
export const getRoster =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { data } = await api.get("/sports/roster", { params });
      dispatch({ type: "ROSTER_SUCCESS", payload: data.roster });
      return data.roster;
    } catch (err) {
      dispatch({ type: "SPORTS_FAIL", payload: err.response?.data?.message });
    }
  };
export const enrollStudent = (d) => async (dispatch) => {
  try {
    await api.post("/sports/enroll", d);
    dispatch(getSports());
  } catch (err) {
    throw err;
  }
};
export const removeEnrollment = (id) => async (dispatch) => {
  try {
    await api.delete(`/sports/enroll/${id}`);
  } catch (err) {
    throw err;
  }
};

// ── Achievements ──
export const getAchievements =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { data } = await api.get("/sports/achievements", { params });
      dispatch({ type: "ACHIEVEMENTS_SUCCESS", payload: data.achievements });
    } catch (err) {}
  };
export const addAchievement = (d) => async (dispatch) => {
  try {
    await api.post("/sports/achievements", d);
    dispatch(getAchievements());
  } catch (err) {
    throw err;
  }
};

// ── Teams ──
export const getTeams =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { data } = await api.get("/sports/teams", { params });
      dispatch({ type: "TEAMS_SUCCESS", payload: data.teams });
      return data.teams;
    } catch (err) {}
  };
export const createTeam = (d) => async (dispatch) => {
  try {
    const { data } = await api.post("/sports/teams", d);
    dispatch(getTeams());
    return data;
  } catch (err) {
    throw err;
  }
};
export const deleteTeam = (id) => async (dispatch) => {
  try {
    await api.delete(`/sports/teams/${id}`);
    dispatch(getTeams());
  } catch (err) {
    throw err;
  }
};
export const addTeamMember = (d) => async (dispatch) => {
  try {
    await api.post("/sports/teams/members", d);
    dispatch(getTeams());
  } catch (err) {
    throw err;
  }
};
export const removeTeamMember = (id) => async (dispatch) => {
  try {
    await api.delete(`/sports/teams/members/${id}`);
    dispatch(getTeams());
  } catch (err) {
    throw err;
  }
};

// ── Tournaments ──
export const getTournaments =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { data } = await api.get("/sports/tournaments", { params });
      dispatch({ type: "TOURNAMENTS_SUCCESS", payload: data.tournaments });
      return data.tournaments;
    } catch (err) {}
  };
export const createTournament = (d) => async (dispatch) => {
  try {
    const { data } = await api.post("/sports/tournaments", d);
    dispatch(getTournaments());
    return data;
  } catch (err) {
    throw err;
  }
};
export const updateTournament = (id, d) => async (dispatch) => {
  try {
    await api.put(`/sports/tournaments/${id}`, d);
    dispatch(getTournaments());
  } catch (err) {
    throw err;
  }
};
export const deleteTournament = (id) => async (dispatch) => {
  try {
    await api.delete(`/sports/tournaments/${id}`);
    dispatch(getTournaments());
  } catch (err) {
    throw err;
  }
};

// ── Leaderboard ──
export const getLeaderboard =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { data } = await api.get("/sports/leaderboard", { params });
      dispatch({ type: "LEADERBOARD_SUCCESS", payload: data.entries });
      return data.entries;
    } catch (err) {}
  };
export const upsertLeaderboardEntry = (d) => async (dispatch) => {
  try {
    const { data } = await api.post("/sports/leaderboard", d);
    return data;
  } catch (err) {
    throw err;
  }
};
export const deleteLeaderboardEntry = (id) => async (dispatch) => {
  try {
    await api.delete(`/sports/leaderboard/${id}`);
  } catch (err) {
    throw err;
  }
};

// ── Ground booking ──
export const getGroundBookings =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { data } = await api.get("/sports/ground", { params });
      dispatch({ type: "GROUND_BOOKINGS_SUCCESS", payload: data.bookings });
      return data.bookings;
    } catch (err) {}
  };
export const bookGround = (d) => async (dispatch) => {
  try {
    const { data } = await api.post("/sports/ground", d);
    dispatch(getGroundBookings());
    return data;
  } catch (err) {
    throw err;
  }
};
export const updateGroundBooking = (id, d) => async (dispatch) => {
  try {
    await api.put(`/sports/ground/${id}`, d);
    dispatch(getGroundBookings());
  } catch (err) {
    throw err;
  }
};
export const cancelGroundBooking = (id) => async (dispatch) => {
  try {
    await api.delete(`/sports/ground/${id}`);
    dispatch(getGroundBookings());
  } catch (err) {
    throw err;
  }
};

// ── Self view ──
export const getMySport = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/sports/my-sport", { params });
    dispatch({ type: "MY_SPORT_SUCCESS", payload: data.sports });
    return data.sports;
  } catch (err) {
    dispatch({ type: "SPORTS_FAIL", payload: err.response?.data?.message });
  }
};
export const getMyPerformance = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/sports/my-performance", { params });
    dispatch({ type: "MY_PERFORMANCE_SUCCESS", payload: data });
    return data;
  } catch (err) {
    dispatch({ type: "SPORTS_FAIL", payload: err.response?.data?.message });
  }
};
